import React from 'react'
import styles from './MediaDrawerCollectionStyles.module.scss'
import PlayInDrawer from '../PlayInDrawer'
import SlidesDrawer from '../SlidesDrawer'
import SpotlightDrawer from '../SpotlightDrawer'
import classnames from 'classnames'
import constants from '@bt-react/constants'

export default ({ slidesEnabled, playInEnabled, spotlightEnabled, selectedDrawer }) => {

  const getClassNames = (name) => {

    return classnames({
      [styles['hidden']]: name !== selectedDrawer
    })

  }

  return <div className={styles['media-drawer-collection']}>
    { playInEnabled && <div className={getClassNames(constants.drawerType.PLAY_IN)}><PlayInDrawer /></div> }
    { slidesEnabled && <div className={getClassNames(constants.drawerType.SLIDES)}><SlidesDrawer /></div> }
    { spotlightEnabled && <div className={getClassNames(constants.drawerType.SPOTLIGHT)}><SpotlightDrawer /></div>}
  </div>

}
